import { Spinner } from '@nextui-org/react';
import { cva } from 'class-variance-authority';
import React from 'react';
import { cn } from '../../lib/utils';

function Loading({
  label = 'Fetching Major...',
  className,
}: {
  label?: string;
  className?: string;
}) {
  const defaultStyle = cva('flex items-center justify-center mt-[15rem]');
  return (
    <Spinner
      className={cn(defaultStyle({ className }))}
      label={label}
      color="warning"
    />
  );
}

export default Loading;
